import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { _registerDialogFns } from '../../core/dialog';

const DialogProvider = ({ children }) => {
    const [dialog, setDialog] = useState(null);

    const showConfirm = useCallback((message) => {
        return new Promise((resolve) => {
            setDialog({ type: 'confirm', message, resolve });
        });
    }, []);

    const showAlert = useCallback((message) => {
        return new Promise((resolve) => {
            setDialog({ type: 'alert', message, resolve });
        });
    }, []);

    useEffect(() => {
        _registerDialogFns(showConfirm, showAlert);
        return () => _registerDialogFns(null, null);
    }, [showConfirm, showAlert]);

    const handleConfirm = () => {
        dialog.resolve(true);
        setDialog(null);
    };

    const handleCancel = () => {
        dialog.resolve(false);
        setDialog(null);
    };

    const handleAlertClose = () => {
        dialog.resolve();
        setDialog(null);
    };

    return (
        <>
            {children}
            {dialog && createPortal(
                <div className="modal-overlay" style={{zIndex: 10500}}>
                    <div className="modal-content dialog-box">
                        <p className="dialog-message">{dialog.message}</p>
                        <div className="dialog-actions">
                            {dialog.type === 'confirm' ? (
                                <>
                                    <button className="back-button" onClick={handleCancel}>Não</button>
                                    <button onClick={handleConfirm}>Sim</button>
                                </>
                            ) : (
                                <button onClick={handleAlertClose}>OK</button>
                            )}
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default DialogProvider;
